/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadSpace } from '@usersnap/browser';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { hmrBootstrap } from './hmr';
import { AppConfig, RuntimeConfig } from '@app/app.config';

fetch('/assets/config.json').then(async (res) => {
  const runtimeConfig = (await res.json()) as RuntimeConfig;
  const appConfig = AppConfig.load(runtimeConfig);

  if (environment.production) {
    enableProdMode();
  }

  const bootstrap = () =>
    platformBrowserDynamic([{ provide: AppConfig, useValue: appConfig }]).bootstrapModule(AppModule);

  const usersnapSpaceApiKey = runtimeConfig.usersnapSpaceApiKey?.trim();
  const usersnapProjectApiKey = runtimeConfig.usersnapProjectApiKey?.trim();

  if (usersnapSpaceApiKey) {
    loadSpace(usersnapSpaceApiKey)
      .then((api) => {
        api.init();

        if (usersnapProjectApiKey) {
          api.show(usersnapProjectApiKey);
        }
      })
      .catch((err) => console.error('Unable to load Usersnap', err));
  }

  if (environment.hmr) {
    hmrBootstrap(module, bootstrap);
  } else {
    bootstrap().catch((err) => console.error(err));
  }
});
